import { flexRender } from "@tanstack/react-table";
import styles from "./recent-properties.module.scss";
import { scrollToTop } from "../../utils/const";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import Pagination from "../common/pagination";
import { useEffect, useRef, useState } from "react";
import NoDataFoundC from "../common/no-data-found";
import ReactTableSkeleton from "../../skeleton/dashboard/ReactTable";

const YourOffers = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const pageParams = Number(queryParams.get("page")) || 1;
  const limitParams = Number(queryParams.get("limit")) || 10;

  const [first, setFirst] = useState<any>((pageParams - 1) * limitParams);
  const [rows, setRows] = useState<any>(limitParams);

  const onPageChange: any = (e: { first: number; rows: number }) => {
    const newPage = e.first / e.rows + 1;
    setFirst(e.first);
    setRows(e.rows);

    navigate({
      search: `?${createSearchParams({
        panel: String(queryParams.get("panel") || "1"),
        page: String(newPage),
        limit: String(e.rows)
      })}`
    });
  };

  useEffect(() => {
    const pageFromURL = Number(queryParams.get("page")) || 1;
    const rowsFromURL = Number(queryParams.get("limit")) || 10;
    setFirst((pageFromURL - 1) * rowsFromURL);
    setRows(rowsFromURL);
  }, [location.search]);

  useEffect(() => {
    const pageFromURL = Number(queryParams.get("page")) || 1;
    const rowsFromURL = Number(queryParams.get("limit")) || 10;
    setFirst((pageFromURL - 1) * rowsFromURL);
    setRows(rowsFromURL);
  }, [location.search]);
  const listingWrapRef = useRef<any>(null);

  useEffect(() => {
    // Wait until the data is loaded and `columnWrap` is rendered
    if (props.recentPropertyData?.length > 0 && listingWrapRef.current) {
      const handleScroll = () => {
        if (listingWrapRef.current) {
          sessionStorage.setItem(
            "scrollPositionOffer",
            listingWrapRef.current.scrollTop.toString()
          );
        }
      };

      const listingWrap = listingWrapRef.current;
      listingWrap?.addEventListener("scroll", handleScroll);

      // Clean up scroll listener
      return () => {
        listingWrap?.removeEventListener("scroll", handleScroll);
      };
    }
  }, [props.recentPropertyData]);

  useEffect(() => {
    // Restore scroll position after data is loaded and ref is assigned
    if (props.recentPropertyData?.length > 0 && listingWrapRef.current) {
      const savedScrollPosition = sessionStorage.getItem("scrollPosition");
      if (savedScrollPosition && listingWrapRef.current) {
        listingWrapRef.current.scrollTo(0, parseInt(savedScrollPosition, 10));
      }
    }
  }, [props.recentPropertyData]);
  return (
    <>
      {props.isLoading ? (
        <>
          <ReactTableSkeleton yourOffersTab={false} />
        </>
      ) : (
        <>
          {props.recentPropertyData?.length !== 0 ? (
            <div
              className={styles.propertyTable}
              style={{
                opacity: props.isPlaceholderData ? 0.5 : 1
              }}
            >
              <div className={styles.propertyColumn}>
                <div className={styles.columnWrap} ref={listingWrapRef}>
                  <table id="recentPropertyColumns">
                    <thead id="header">
                      {props.recentPropertyData?.length > 0 &&
                        props.table
                          ?.getHeaderGroups()
                          ?.map((headerGroup: any) => (
                            <tr key={headerGroup.id}>
                              {headerGroup?.headers?.map((header: any) => {
                                return (
                                  <th key={header.id} colSpan={header.colSpan}>
                                    {header.isPlaceholder ? null : (
                                      <div>
                                        {flexRender(
                                          header.column.columnDef.header,
                                          header.getContext()
                                        )}
                                      </div>
                                    )}
                                  </th>
                                );
                              })}
                            </tr>
                          ))}
                    </thead>
                    <tbody>
                      {props.recentPropertyData?.length > 0 &&
                        props.table?.getRowModel()?.rows.map((row: any) => {
                          return (
                            <tr
                              key={row.id}
                              tabIndex={0}
                              onClick={(e: any) => {
                                if (
                                  e.target.tagName !== "SPAN" &&
                                  e.target.tagName !== "svg" &&
                                  e.target.tagName !== "path" &&
                                  e.target.tagName !== "A"
                                ) {
                                  scrollToTop();
                                  navigate(`/internal/${row.original.id}`, {
                                    state: {
                                      propertyDetails: row.original,
                                      objPropertyDetails:
                                        props.objPropertyDetails
                                    }
                                  });
                                }
                              }}
                            >
                              {row?.getAllCells()?.map((cell: any) => {
                                return (
                                  <td key={cell.id}>
                                    {flexRender(
                                      cell.column.columnDef.cell,
                                      cell.getContext()
                                    )}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                {props?.recentPropertyData?.length > 0 && (
                  <div className={styles.pagination}>
                    <Pagination
                      first={first}
                      rows={rows}
                      totalRecords={props.totalCount}
                      onPageChange={onPageChange}
                    />
                  </div>
                )}
              </div>
            </div>
          ) : (
            // <div className={styles.noDataContainer}>
            <NoDataFoundC panelIndex={props.panelIndex} />
            // </div>
          )}
        </>
      )}
    </>
  );
};
export { YourOffers };
